/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbQuerySyncLogStatus extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceNowCmdbQuerySyncLogStatus");
    }

    getFixupPrototypeFunction() { return ServiceNowCmdbQuerySyncLogStatus.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbQuerySyncLogStatus>): ServiceNowCmdbQuerySyncLogStatus {
        let obj = Object.assign(new ServiceNowCmdbQuerySyncLogStatus(), model);
        ServiceNowCmdbQuerySyncLogStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbQuerySyncLogStatus>): ServiceNowCmdbQuerySyncLogStatus {
        if (!model) return null;
        return ServiceNowCmdbQuerySyncLogStatus.newInstance(<ServiceNowCmdbQuerySyncLogStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbQuerySyncLogStatus) {
        if (!obj) return;

        models.ServiceNowCmdbQuerySyncLogStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbQuerySyncLogStatus): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbQuerySyncLogStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource Sync Status
     */
    statuses: Array<models.ServiceNowCmdbSyncLogStatus>;

}
